const colors = {
  darkGray: "#303030",
  lightBlue: "#4ea3d8",
  offWhite: "#eee",
  lightGray: "#aaa",
  error: "#f00"
};

const customTheme = {
  palette: {
    type: "light",
    primary: {
      main: colors.lightBlue,
      contrastText: "#fff"
    },
    secondary: {
      main: colors.offWhite,
      contrastText: "#000"
    }
  },
  typography: {
    useNextVariants: true,
    fontFamily: ["Open Sans", "sans-serif"]
  },
  overrides: {
    MuiCardHeader: {
      title: {
        fontSize: 16,
        marginBottom: "5px",
        fontWeight: "bold"
      },
      subheader: {
        fontSize: 14
      }
    },
    MuiIconButton: {
      root: {
        marginTop: "5px",
        marginBottom: "5px"
      }
    }
  }
};

export default customTheme;



// WEBPACK FOOTER //
// ./src/themes/customBaseTheme.js